import { NavigationBar, SimpleMenu, SimpleMenuItem, useMenuState } from "@octopusdeploy/design-system-components";
import { ChevronDownIcon } from "@octopusdeploy/design-system-icons";
import { backgroundTasksRouteLinks } from "areas/backgroundTasks/backgroundTasksRouteLinks";
import { EnvironmentName } from "client/resources/environmentName";
import Dialog from "components/Dialog/Dialog";
import EnhancedDialogTrigger from "components/Dialog/DialogTrigger";
import externalSystemLinks from "externalSystemLinks";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { RunSqlForCloudPortalDialog } from "./RunSqlForCloudPortalDialog";

interface OwnProps {
    environment?: EnvironmentName;
}

type Props = OwnProps & RouteComponentProps<void>;

const helpLinks: Record<string, string> = {
    "/": "https://github.com/OctopusDeploy/hosted-docs/blob/master/portal/dashboard.md",
};

const PortalMenu: React.FC<Props> = ({ environment, history, location }) => {
    const [openMenu, menuState, buttonAriaAttributes] = useMenuState();
    const helpHref = helpLinks[location.pathname];

    return (
        <EnhancedDialogTrigger render={({ open, openDialog }) => {
            const items: SimpleMenuItem[] = [
                { type: "button", label: "Run SQL", onClick: openDialog },
                ...(helpHref ? [{ type: "external-link" as const, label: "Help", href: helpHref }] : []),
                ...(environment ? [
                    { type: "divider" as const },
                    { type: "external-link" as const, label: "Seq", href: externalSystemLinks.seq.portalLogs(environment) },
                    { type: "external-link" as const, label: "Sumo", href: externalSystemLinks.sumoLogic.portalLogs(environment) },
                    { type: "external-link" as const, label: "Sumo (Octopus org)", href: externalSystemLinks.sumoLogic.sharedPortalLogs(environment) },
                    { type: "external-link" as const, label: "Sumo MQS dashboard", href: externalSystemLinks.sumoLogic.mqsDashboard() },
                    { type: "external-link" as const, label: "Honeycomb Traces", href: externalSystemLinks.honeycomb.allPortalTraces() },
                ] : []),
            ];

            return (
                <div>
                    <NavigationBar.Button label="Portal" icon={<ChevronDownIcon size={24} />} accessibleName="Open Portal menu" onClick={openMenu} {...buttonAriaAttributes} />
                    <SimpleMenu menuState={menuState} items={items} accessibleName="Portal" />
                    <Dialog open={open}>
                        <RunSqlForCloudPortalDialog
                            busy={false}
                            errors={null}
                            instance={null}
                            onSaveClick={(backgroundTaskId: string) => {
                                history.push(backgroundTasksRouteLinks.task(backgroundTaskId).root);
                                return Promise.resolve(true);
                            }}
                        />
                    </Dialog>
                </div>
            );
        }} />
    );
};

export default withRouter<Props>(PortalMenu);
